// src/pages/History/20thCentury/ColdWarGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/20th_Century_-_Cold_War.png';

function HistoryPageColdWarGo() {
  return (
    <QuizPage
      title="History: Cold War"
      subTopic="Cold War"
      backgroundImage={historyImage}
      returnPath="/History-Cold-War"
    />
  );
}

export default HistoryPageColdWarGo;
